import {GitHubAvatar} from '@github-ui/github-avatar'
import {userHovercardPath} from '@github-ui/paths'
import type {User} from '@github-ui/user-selector'
import {Link} from '@primer/styled-react'

import {useActivityAnalytics} from '../hooks/use-activity-analytics'

export function Pusher({pusher}: {pusher: User}) {
  const {sendActivityClickEvent} = useActivityAnalytics()
  return (
    <Link
      aria-label={`View ${pusher.login} profile`}
      muted
      href={pusher.path}
      data-hovercard-url={userHovercardPath({owner: pusher.login})}
      onClick={() => sendActivityClickEvent('PUSHER_LINK')}
      sx={{
        fontWeight: 600,
        mr: 1,
        color: 'fg.default',
        '&:hover': {color: 'fg.default', textDecoration: 'underline'},
      }}
    >
      <GitHubAvatar
        sx={{mr: 2, cursor: 'pointer'}}
        src={pusher.primaryAvatarUrl}
        square={pusher.path.startsWith('/apps/')}
      />
      {pusher.login}
    </Link>
  )
}

try{ Pusher.displayName ||= 'Pusher' } catch {}